import { useEffect, useState } from "react";

const useCources = () => {
  const [course, setCourse] = useState([]);
  useEffect(() => {
    fetch("cources.json")
    .then((res) =>res.json()
    .then((data) => setCourse(data))
    );
  }, []);

  return [course, setCourse];
};

export default useCources;
